<!-- 优质工作室 -->
<template>
    <section class="indBlock titLeft bgw">
        <div class="container">
            <div class="hd clearfix">
                <h3><a href="#">优质工作室</a></h3>
                <div class="introTxt">高效优质工作室分享</div>
                <div class="more"><a class="btn hoverBg" href="#" v-if="false">更多</a></div>
            </div>
            <div class="bd">
                <table class="wmTable mt30">
                    <tr>
                        <th>所属高校</th>
                        <th>工作室</th>
                        <th>工作室评级</th>
                        <th>累计完成项目数</th>
                    </tr>
                    <tr v-for="(item, index) in list" :key="index">
                        <td>{{item.universities}}</td>
                        <td>{{item.studio}}</td>
                        <td>{{item.rate}}</td>
                        <td>{{item.num}}</td>
                    </tr>
                </table>
            </div>
            <div class="fd">
                <a class="btn bigBtn blueSty hoverShadow" href="#" v-if="false">更多工作室</a>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'QualityStudio',
        data(){
            return {
                list:[
                    {
                        "num": 11,
                        "rate": "A",
                        "studio": "泰迪·黔南师院数统智能工作室",
                        "universities": "黔南民族师范学院计算机与信息学院"
                    },
                    {
                        "num": 8,
                        "rate": "A",
                        "studio": "泰迪·广西科大智能工作室",
                        "universities": "广西科技大学"
                    },
                    {
                        "num": 2,
                        "rate": "A",
                        "studio": "泰迪·广科院智能工作室",
                        "universities": "广东科学技术职业学院"
                    },
                    {
                        "num": 14,
                        "rate": "B",
                        "studio": "泰迪·广工大智能工作室",
                        "universities": "广东工业大学应用数学学院"
                    },
                    {
                        "num": 12,
                        "rate": "B",
                        "studio": "泰迪·西安欧亚智能工作室",
                        "universities": "西安欧亚学院金融学院"
                    },
                    {
                        "num": 10,
                        "rate": "B",
                        "studio": "泰迪·上商智能工作室",
                        "universities": "上海商学院计算机科学与技术学院"
                    },
                    {
                        "num": 8,
                        "rate": "B",
                        "studio": "泰迪·华北理工智能工作室",
                        "universities": "华北理工大学理学院"
                    },
                    {
                        "num": 7,
                        "rate": "B",
                        "studio": "泰迪·五邑大学智能工作室",
                        "universities": "五邑大学"
                    },
                    {
                        "num": 6,
                        "rate": "B",
                        "studio": "泰迪·东北农大智能工作室",
                        "universities": "东北农业大学数学与统计学院"
                    },
                    {
                        "num": 6,
                        "rate": "B",
                        "studio": "泰迪·中南大智能工作室",
                        "universities": "中南财经政法大学数学学院"
                    },
                    {
                        "num": 6,
                        "rate": "B",
                        "studio": "泰迪·绍职院智能工作室",
                        "universities": "绍兴职业技术学院信息工程学院"
                    },
                    {
                        "num": 6,
                        "rate": "B",
                        "studio": "泰迪·石铁大智能工作室",
                        "universities": "石家庄铁道大学大数据学院"
                    },
                    {
                        "num": 6,
                        "rate": "B",
                        "studio": "泰迪·广软学院智能科学工作室",
                        "universities": "广州大学华软软件学院"
                    },
                    {
                        "num": 5,
                        "rate": "B",
                        "studio": "泰迪·岭南师院智能工作室",
                        "universities": "岭南师范学院数学与统计学院"
                    },
                    {
                        "num": 4,
                        "rate": "B",
                        "studio": "泰迪·华南师大智能工作室",
                        "universities": "华南师范大学数学科学学院"
                    },
                    {
                        "num": 4,
                        "rate": "B",
                        "studio": "泰迪·嘉应学院智能工作室",
                        "universities": "嘉应学院"
                    },
                    {
                        "num": 4,
                        "rate": "B",
                        "studio": "泰迪·西华智能工作室",
                        "universities": "西华大学"
                    },
                    {
                        "num": 4,
                        "rate": "B",
                        "studio": "泰迪·浙财大智能工作室",
                        "universities": "浙江财经大学"
                    },
                    {
                        "num": 3,
                        "rate": "B",
                        "studio": "泰迪·贵医大智能工作室",
                        "universities": "贵州医科大学大健康学院"
                    },
                    {
                        "num": 3,
                        "rate": "B",
                        "studio": "泰迪·重理工智能工作室",
                        "universities": "重庆理工大学"
                    },
                    {
                        "num": 3,
                        "rate": "B",
                        "studio": "泰迪·广州理工智能工作室",
                        "universities": "广州理工学院"
                    },
                    {
                        "num": 3,
                        "rate": "B",
                        "studio": "泰迪·西华师大智能双创工作室",
                        "universities": "西华师范大学"
                    },
                    {
                        "num": 2,
                        "rate": "B",
                        "studio": "泰迪·广东邮电智能工作室",
                        "universities": "广东邮电职业学院"
                    }
                ]
            }
        }
    }
</script>